export const routes = {
    INDEX: '/',
    SIGN_IN: '/sign-in',
    /** The new sign-in's other screens: code, expired, paused, team-removed, client, signed-out, welcome, invite. */
    SIGN_IN_STEP: '/sign-in/:step',
    FIRST_LOG_IN: '/first-log-in',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/new-password',
    ADMIN_PAGE: '/',
    MAIN: '/trainer',
};
